import React, { useEffect, useState } from 'react'
import { useRequest } from '../../../hooks/useRequest'
import TableV1 from '../../Resources/TableV1/TableV1'
import TitleContainer from '../../Resources/TitleContainer/TitleContainer'
import classes from './PaymentLists.module.css'

export default function PaymentLists({ loading, paymentList }) {
    console.log({ paymentList })

    return (
        <div>
            <TitleContainer title="Subscription Payment Lists" isCount={true} count={paymentList[0]?.results} />

            <TableV1>
                <thead>
                    <tr className={classes.tableRow}>
                        <th>SL</th>
                        <th>Txn ID</th>
                        <th>Phone</th>
                        <th>Plan</th>
                        <th>Duration</th>
                        <th>Payable</th>
                        <th>Paid</th>
                        <th>Seller ID</th>
                        <th>Company Name</th>
                        <th>Date</th>
                    </tr>
                </thead>

                <tbody>
                    {paymentList[1]?.map((item, index) => {
                        const payment = item.SubscriptionPayment
                        const seller = item.Seller
                        const user = item.User
                        const SubscriptionPayment = item.SubscriptionPayment

                        return (
                            <tr key={index} className={classes.row}>
                                <td>{index + 1}</td>
                                <td>{SubscriptionPayment?.reference_number}</td>
                                <td>{user?.phone}</td>
                                <td>{payment?.plan_name}</td>
                                <td>{SubscriptionPayment?.duration}</td>
                                <td>{payment?.payable_amount}</td>
                                <td>{payment?.paid_amount}</td>
                                <td>{seller?.seller_full_id}</td>
                                <td>{seller?.page_name}</td>
                                <td>{payment?.book_date?.slice(0, 10)}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </TableV1>
        </div>
    )
}
